<template>
  <v-btn
    v-if="!rail"
    icon
    variant="text"
    :disabled="disabled"
    :loading="loadingToggles"
    @click="reloadToggles"
  >
    <v-icon>refresh</v-icon>
  </v-btn>
  <ParameterSelectDialog v-if="!rail" nav></ParameterSelectDialog>
  <div v-if="!rail" class="pa-5">
    <v-divider></v-divider>
    <ConfigInput
      v-for="item in settings"
      :key="item['mbus address'] + '-quick-item'"
      :parameter="item"
      :significance="5"
      show-group
      modbus-reload
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import ParameterSelectDialog from "./ParameterSelectDialog.vue";
import ConfigInput from "@/components/ConfigInput.vue";
import { ParamField } from "../enums/ParamField";
import { PortState } from "@/enums/PortState";
import { useModbusStore } from "@/stores/useModbusStore";
import { ModbusParam } from "@/types/ModbusParam";

const modbusStore = useModbusStore();

defineProps({
  rail: {
    type: Boolean,
    required: true,
  },
});
const settings = computed<ModbusParam[]>(() => {
  return modbusStore.quickParams.filter(
    (param) =>
      modbusStore.selectedQuickParams[param[ParamField.mbusAddress]] == true,
  );
});
const disabled = computed(() => {
  return modbusStore.portState === PortState.disconnected;
});
const loadingToggles = computed(() => {
  let res = false;
  settings.value.forEach((item) => {
    res =
      res ||
      modbusStore.modbusAddrReadBusy[item[ParamField.mbusAddress]] ||
      modbusStore.modbusAddrWriteBusy[item[ParamField.mbusAddress]];
  });
  return res;
});
function reloadToggles() {
  settings.value.forEach((item) => {
    if (modbusStore.storeInit && modbusStore.portState == PortState.connected) {
      //-------- Device Info -------------------------
      modbusStore.modbusRead(
        modbusStore.deviceAddress,
        parseInt(item[ParamField.mbusAddress]),
        modbusStore.modbusAddrLength[parseInt(item[ParamField.mbusAddress])],
      );
    }
  });
}
onMounted(() => {
  const quick_params = localStorage.getItem(
    "charts_page" + modbusStore.portIndex.toString() + "/quickparams",
  );
  if (quick_params) {
    const params_array = JSON.parse(quick_params);
    for (let i = 0; i < quick_params.length; i++) {
      modbusStore.selectedQuickParams[params_array[i]] = true;
    }
  }
});
</script>

<style scoped lang="scss">
.rotated {
  transform: rotate(180deg);
}
</style>
